const { default: Styled } = require('styled-components');
const T = require('prop-types');
const SortBy = require('lodash/sortBy');
const Storage = require('utils/storage');
const PersistenceConfig = require('utils/persistence-config');

const { default: FormControl } = require('@mui/material/FormControl');
const { default: Select } = require('@mui/material/Select');
const { default: MenuItem } = require('@mui/material/MenuItem');
const { default: ListItemText } = require('@mui/material/ListItemText');

const SelectInputLabel = require('components/SelectInputLabel');

const internals = {};

module.exports = function AppContextFilter(props) {

    const {
        appContextFilter: propAppContextFilter,
        setAppContextFilter,
        onChange,
        availableRoleGroups,
        hideOptions,
        myGroupsPage,
        labelId
    } = props;

    const {
        StyledFormControl,
        StyledSelect
    } = internals;

    const appContextFilter = myGroupsPage
        ? (Storage.session.get(PersistenceConfig.keys.app.groupsContextFilter) || propAppContextFilter)
        : propAppContextFilter;

    const handleChange = (event) => {

        const val = event.target.value;
        setAppContextFilter({
            filter: val
        });

        if (myGroupsPage) {
            Storage.session.set(PersistenceConfig.keys.app.groupsContextFilter, val);
        }

        if (onChange) {
            onChange(val);
        }
    };

    const filteredoptions = availableRoleGroups && availableRoleGroups.filter((option) => {

        return !hideOptions || !hideOptions.includes(option.name);
    });

    const sortedOptions = SortBy(filteredoptions, ['sortOrder']);

    if (!availableRoleGroups || !availableRoleGroups.length) {
        return null;
    }

    if (filteredoptions.length <= 1) {
        return (
            <div style={{
                position: 'relative',
                width: 150,
                height: 57,
                maxWidth: 150,
                maxHeight: 57
            }}>
                <div style={{
                    padding: '10px 0',
                    transform: 'translate(0, -4px) scale(0.75)',
                    position: 'absolute',
                    left: -5,
                    top: 0,
                    color: 'rgba(0, 0, 0, 0.54)'
                }}>
                    Role:
                </div>
                <div style={{
                    marginTop: 22,
                    width: 126,
                    height: 32,
                    padding: '4px 24px 5px 0'
                }}>
                    {filteredoptions[0].label}
                </div>
            </div>
        );
    }

    return (
        <StyledFormControl>
            <SelectInputLabel id='role-label'>
                Role:
            </SelectInputLabel>
            <Select
                value={appContextFilter}
                onChange={handleChange}
                inputProps={{
                    'aria-labelledby': 'role-label'
                }}
                labelId={labelId}
            >
                <MenuItem value="all">
                    <ListItemText
                        primary="All"
                        primaryTypographyProps={{
                            align: 'left'
                        }}
                    />
                </MenuItem>
                {sortedOptions.map((option) => (

                    <MenuItem
                        key={option.id}
                        value={option.name}
                    >
                        <ListItemText
                            primary={option.label}
                            primaryTypographyProps={{
                                align: 'left'
                            }}
                        />
                    </MenuItem>
                ))}
            </Select>
        </StyledFormControl>
    );
};

module.exports.propTypes = {
    appContextFilter: T.string.isRequired,
    setAppContextFilter: T.func.isRequired,
    onChange: T.func,
    availableRoleGroups: T.array,
    hideOptions: T.array,
    myGroupsPage: T.bool,
    labelId: T.string
};

internals.StyledFormControl = Styled(FormControl)`
    min-width: 150px;
`;
